module.exports = __webpack_public_path__ + "img/lbl-02.f41eab0a.png";